import React from 'react'
import clsx from 'clsx'
import { AddCircle, CloseCircle, Profile2User } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Tooltip from '@SonarCX/components/atoms/Tooltip'
import MediaAvatar from '@SonarCX/components/atoms/MediaAvatar'
import UserSearchDropdown from '@SonarCX/components/molecules/UserSearchDropdown'
import { sortByName } from '@SonarCX/utilities'

const AssignedToSection = ({
  classes,
  values,
  allUsers,
  removeUser,
  canEdit,
  canSearchUser,
  handleChange
}) => {
  const theme = useTheme()
  const sortedAssignees = values.primary
    ? values.primary
        .map(id => {
          const user = allUsers[id]
          if (values.primary_assignee_id && values.primary_assignee_id === id) {
            return null
          }
          if (!user) return null
          return { ...user }
        })
        .filter(Boolean)
        .sort(sortByName)
        .map(i => i.id)
    : []

  return (
    <div className={clsx(classes.center, classes.label, classes.mobile)}>
      <span className={clsx(classes.center, classes.label)}>
        <Profile2User size={theme.size.base} variant='Bulk' color='#B64FCD' />{' '}
        ASSIGNEES
      </span>

      <div className={classes.center}>
        {sortedAssignees.map(id => {
          const user = allUsers[id]

          if (!user) {
            return null
          }

          return (
            <Tooltip key={id} title={user?.name ?? ''} arrow>
              <div className={classes.dismiss}>
                <MediaAvatar key={id} user={user} className={classes.avatar} />

                <CloseCircle
                  size={theme.size.sm}
                  variant='Bulk'
                  color='grey'
                  onClick={() => removeUser('primary', user)}
                  className='close'
                />
              </div>
            </Tooltip>
          )
        })}

        {canEdit && canSearchUser ? (
          <UserSearchDropdown
            prevSelected={[]}
            selected={null}
            onSelect={id => handleChange('primary')({ target: { value: id } })}
            limit={10}
            disablePortal
          >
            <div className={classes.center}>
              <AddCircle size={theme.size.base} variant='Bulk' color='grey' />
              Add
            </div>
          </UserSearchDropdown>
        ) : values.primary.length ? null : (
          <div className={classes.noPermission}>No assignees</div>
        )}
      </div>
    </div>
  )
}

export default AssignedToSection
